import { css } from 'aphrodite';
import { FC } from 'react';
import { INavBarLink } from '../../../../components/NavBarLink';
import { PortalDestination } from '../../../../components/Portal';
import { UserProfileNav } from '../../../../components/UserProfileNav';
import { Row } from '../../../PageLayout';
import { styleSheet } from './styles';

export const AppBarNavigationItemPortalDestinationId = 'AppBarNavigationItemPortalDestinationId';

interface AppBarProps {
	coffeeLinks?: INavBarLink[];
}

export const AppBar: FC<AppBarProps> = ({ coffeeLinks }) => {
	return (
		<Row fullWidth styles={[styleSheet.appBar]}>
			<div className={`app-bar-navigation-item ${css(styleSheet.navItem)}`}>
				<PortalDestination id={AppBarNavigationItemPortalDestinationId} />
			</div>
			<div className={css(styleSheet.rightAccessoryContainer)}>
				<UserProfileNav className={`app-bar-user-profile-button`} coffeeLinks={coffeeLinks} />
				<a className={css(styleSheet.helpLink)} href='https://help.levitate.ai' target='_blank' rel='noreferrer'>
					Help
				</a>
			</div>
		</Row>
	);
};
